import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lng]/(use-auth)/cookiesConsent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/decorators/landing-path.webp");
;
import(/* webpackMode: "eager", webpackExports: ["CustomDiv"] */ "/app/src/common/divs.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/home/home.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/landing/blogEntries.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/landing/economy.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/landing/globalHeader.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/landing/landing.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/landing/mobile.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/landing/numbers.tsx");
